/* src/app/components/submission-device-substances-warnings-eu/submission-device-substances-warnings-eu.component.css */
/*# sourceMappingURL=submission-device-substances-warnings-eu.component.css.map */
